import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler, IonicPageModule } from 'ionic-angular';
import { MyApp } from './app.component';
import { FormsModule, ReactiveFormsModule,Validators } from '@angular/forms';

import { HttpModule} from '@angular/http';

import { AboutIonicPage } from '../pages/about/about';

import { RegisterPage } from '../pages/login/register';
import { LoginComponent } from '../pages/login/login';
import { ForgotComponent } from '../pages/login/forgot';
import { ContactUsComponent } from '../pages/login/contact-us';

import { CommonService } from '../services/common.service';
import { SupportPageModule } from '../pages/support/support.module';
import { QrcodePageModule } from '../pages/qrcode/qrcode.module';

import { RatingCollectorsPageModule } from '../pages/rating-collectors/rating-collectors.module';

import { SharedModule } from '../shared/shared.module';
import { AuthService } from '../providers/auth-service';
import { SettingsPageModule } from '../pages/settings/settings.module';
import { CommentPageModule } from '../pages/comment/comment.module';



//for tooltip
import { TooltipsModule } from 'ionic-tooltips';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

 // Import ionic2-rating module
 import { Ionic2RatingModule } from 'ionic2-rating';

  // Import ionic2-rating module
/* import { WalkthroughModule } from 'angular-walkthrough';
*/


 import { StatusBar } from '@ionic-native/status-bar';
 import { SplashScreen } from '@ionic-native/splash-screen';
 import { UserServiceProvider } from '../providers/user-service/user-service';
 import { Network } from '@ionic-native/network';
 import { Device } from '@ionic-native/device';
 import { AppRate } from '@ionic-native/app-rate';
import { DashboardPageModule } from '../pages/dashboard/dashboard.module';
import { TermsPolicyPage } from '../pages/login/terms-policy';
import { InAppPurchase } from '@ionic-native/in-app-purchase';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient } from '@angular/common/http';


 @NgModule({
   declarations: [
   MyApp,
   AboutIonicPage,
   LoginComponent,  
   RegisterPage,
   TermsPolicyPage,   
   ForgotComponent,
   ContactUsComponent
   


   ],
   imports: [
   BrowserModule,
   IonicModule.forRoot(MyApp),
   HttpModule,
   FormsModule,
    // Including the ReactiveFormsModule in our application
    ReactiveFormsModule,
    Ionic2RatingModule,    
     //DashboardPageModule,
     IonicPageModule,
    //IonicPageModule.forChild(RegisterPage),
    SupportPageModule,
    QrcodePageModule,
    SettingsPageModule,
    CommentPageModule,
    RatingCollectorsPageModule,
    SharedModule,
    TooltipsModule,
    DashboardPageModule,     
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
       provide: TranslateLoader,
       useFactory: (setTranslateLoader),
       deps: [HttpClient]
     }
    })
    ],
    bootstrap: [IonicApp],
    entryComponents: [
    MyApp,
    AboutIonicPage,
    LoginComponent, 
    TermsPolicyPage,   
    RegisterPage,
    ForgotComponent ,
    ContactUsComponent

    ],
    providers: [
    Validators,
    AuthService,
    CommonService,    
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    UserServiceProvider,
    Network,
    Device,
    AppRate,
    InAppPurchase,
    ]

  })
 export class AppModule {}

 export function setTranslateLoader(http: HttpClient ) {
 return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts